import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/basic";
const uuid = require("uuid/v1");

class Process {
  @observable isLoading = false;
  @observable tableData = [];
  @observable procedureList = [];
  @observable bomList = [];
  @observable noTechLineList = [];
  @observable techLineList = [];
  @observable PageInfo = { pageIndex: 1, pageSize: 10 };
  @observable formData = {};
  @observable modalVisible = false;
  @observable componentId = ""; //物料id
  @observable deviceList = [];

  @observable selectedRowKeys = [];
  @observable selectedRows = [];

  @observable isCopy = 1;

  //获取表格数据 ---工艺路线
  @action.bound async getData(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.techLineList,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action.bound async getDeviceList(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getDeviceList,
        params
      );
      if (isDataExist(res)) {
        this.deviceList = res.data.data;
        return res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //获取工序列表
  @action.bound async getProcedure(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.listProcedure,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.procedureList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //获取物料名称
  @action.bound async getBomList(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.allBomList,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.bomList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //获取未配置工艺路线的物料
  @action.bound async getNoTechLine(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.noTechLine,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.noTechLineList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //删除工艺路线
  @action.bound async deleteTechLine(type, params) {
    this.isLoading = true;
    const url = type
      ? services.requestUrl.removeTechLine
      : services.requestUrl.batchRemoveTechLine;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //保存工艺路线
  @action.bound async saveTechLine(type, params) {
    this.isLoading = true;
    const url = type
      ? services.requestUrl.saveTechLine
      : services.requestUrl.updateTechLine;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action async showFile(params) {
    try {
      let res = await services.getRequest(services.requestUrl.showFile, params);
      if (isDataExist(res)) {
        Object.keys(res.data.data).map(key => {
          this.formData.tags2.map(per => {
            if (key === per.procedureId) {
              for (let i of res.data.data[key]) {
                per.defaultFileList.push({
                  uid: uuid(),
                  name: i.fileName || "文件01",
                  status: "done",
                  url: i.url
                });
              }
            }
            return per;
          });
          return key;
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* 根据工序获取设备列表 */
  @action.bound async getProcedureById(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getProcedureById,
        params
      );
      if (isDataExist(res)) {
        return res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //打开/关闭模态框
  @action.bound modalChange = (type, record) => {
    if (type) {
      let tags2 = JSON.parse(JSON.stringify(record.procedureDoList));
      //默认选中工序
      let procedureIdList = [];
      for (let i = 0; i < tags2.length; ++i) {
        tags2[i].deviceList = [];
        // 工序相关设备列表
        // this.getProcedureById({procedureId:tags2[i].procedureId}).then((data)=>{
        //     tags2[i].deviceList=data
        // })
        // 默认选择的关联设备
        let tempDeviceList = [];
        let tempDeviceName = [];
        tags2[i].deviceDoList.map(item => {
          tempDeviceList.push({ deviceId: item.deviceId });
          tempDeviceName.push(item.deviceName);
        });
        tags2[i].deviceDoList = tempDeviceList;
        tags2[i].deviceName = tempDeviceName;
        procedureIdList.push(tags2[i].procedureId);
      }
      this.formData = {
        ...record,
        procedureIdList: procedureIdList,
        tags2: tags2
      };
    } else {
      this.formData = {};
    }
    this.modalVisible = !this.modalVisible;
  };

  /* 工艺参数定义 */
  //获取表格数据
  @action.bound async getTechParams(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.processList,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action clearData() {
    this.isLoading = false;
    this.tableData = [];
    this.procedureList = [];
    this.bomList = [];
    this.noTechLineList = [];
    this.techLineList = [];
    this.PageInfo = { pageIndex: 1, pageSize: 10 };
    this.formData = {};
    this.modalVisible = false;
    this.componentId = ""; //工序名称
    this.deviceList = [];
    this.selectedRowKeys = [];
    this.selectedRows = [];
    this.isCopy = 1;
  }
}

let ProcessStore = new Process();
export default ProcessStore;
